// extracted by mini-css-extract-plugin
module.exports = {"jobs__card":"styles_jobs__card__PCaXx","rotate":"styles_rotate__11tD2","rotate-reverse":"styles_rotate-reverse__iholC"};